module.exports = __webpack_public_path__ + "static/media/barbie.9f2100e1.png";